import { render, staticRenderFns } from "./invitePaper2.vue?vue&type=template&id=537cff16&"
import script from "./invitePaper2.vue?vue&type=script&lang=js&"
export * from "./invitePaper2.vue?vue&type=script&lang=js&"
import style0 from "./invitePaper2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports